import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { HorizontalBox } from '../../../component/layout/BoxLayout';
import { RowSelectionState } from '../../../component/table/useManualRowSelection';
import { AdditionalEmployeeColumns, EmployeeBenefitStatusList } from './EmployeeBenefitStatusList';
import { EmployeeFilterSelector } from './EmployeeFilterSelector';
import { EmployeeFilterState, useApplyHiddenEmployeeFilter } from './employeeFilterState';

interface Props {
  benefit: BenefitDTOBenefitEnum;
  customBenefitId?: string;
  filterState: EmployeeFilterState;
  rowSelectionState: RowSelectionState;
  additionalColumns?: AdditionalEmployeeColumns;
}

export const EmployeeBenefitStatusPanel = ({
  benefit,
  customBenefitId,
  filterState,
  rowSelectionState,
  additionalColumns,
}: Props): React.JSX.Element => {
  const sourceFilterEnabled = useApplyHiddenEmployeeFilter(filterState);

  return (
    <>
      <HorizontalBox sx={{ gap: 1, marginBottom: 1.5 }}>
        <EmployeeFilterSelector
          filterState={filterState}
          showBenefitFilter={filterState.debouncedFilter.activationState !== 'ACTIVE'}
          showStatusFilter
          showHiddenFilter={sourceFilterEnabled}
        />
      </HorizontalBox>
      <EmployeeBenefitStatusList
        benefit={benefit}
        customBenefitId={customBenefitId}
        filter={filterState.debouncedFilter}
        rowSelectionState={rowSelectionState}
        additionalColumns={additionalColumns}
      />
    </>
  );
};
